module.exports = __webpack_public_path__ + "kxp-7f7fc32eb5db77650719.png";